import styled from "styled-components";

export const EditorInfoSearchWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: flex-start;
`;

export const EditorInfoSearchTitle = styled.div`
  display: flex;
  flex: 1;
  width: 19.2rem;
  max-width: 19.2rem;
  align-items: flex-start;
`;
